<template>
  <calendar-header :top-left-cell-contents="topLeftCellContents" :caption-contents="captionContents" />
  <div id="calander_grid" ref="calander_grid">
    <table class="calander_table fixed_headers">
      <calendar-cols />
      <tbody>
      <tr v-for="year in yearList" :key="year" class="calendar_row">
        <th class="year_header has-text-centered">{{year}}</th>
        <td v-for="month in monthList" :key="month" @click="monthClick(year, month)">
          <component :is="monthComponent" :month="month" :year="year" />
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>
<script setup>
import CalendarCols from "./CalendarGrid/CalendarCols.vue";
import CalendarHeader from "./CalendarGrid/CalendarHeader.vue";
import { computed, nextTick, onMounted, useTemplateRef, watch } from 'vue';
import { useEventListener } from "@vueuse/core";

const emit = defineEmits(["monthClick", "calendarScroll"]);

const props = defineProps({
  startYear: {
    type: Number,
    required: true
  },
  endYear: {
    type: Number,
    required: true
  },
  monthComponent: {
    type: Object,
    required: true
  },
  topLeftCellContents: {
    type: String,
    default: "Years"
  },
  captionContents: {
    type: String
  }
});

const calendarGrid = useTemplateRef("calander_grid");

const yearList = computed(() => {
  const years = [];
  for (let x = props.startYear; x <= props.endYear; x++) {
    years.push(x);
  }
  return years;
});

const monthList = computed(() => [...Array(12).keys()]);

function monthClick(year, month) {
  emit("monthClick", year, month);
}

useEventListener(calendarGrid, "scroll", () => {
  emit("calendarScroll");
});

onMounted(() => {
  watch(() => [props.startYear, props.endYear], () => {
    nextTick(() => {
      calendarGrid.value.scrollTop = calendarGrid.value.scrollHeight;
    });
  }, { immediate: true });
});

</script>

<style lang="scss">
// not scoped to apply styling to slot content
@use "./styles/variables.scss" as v;

#calander_grid{
  flex-grow: 1;
  overflow-y: auto;
  overflow-x: hidden;
}

.calander_table{
  background: white;
  width: v.$page_width;
}

.calendar_row {
  td{
    border: 1px solid #dbdbdb;
  }
  th {
    text-align: center;
  }
}

.vertical_text {
  writing-mode: vertical-rl; /* Rotates the text vertically */
  transform: rotate(180deg);  /* Flips it so it reads bottom-to-top */
  white-space: nowrap;       /* Keeps the text on one line */
  text-align: center;
}
</style>